import * as React from "react"

import { cn } from "../../lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-md border border-[#91bfe3] bg-white px-3 py-2 text-sm text-slate-700 placeholder:text-[#91bfe3] file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#2167ae] focus-visible:outline-none focus-visible:border-[#2167ae] focus-visible:ring-1 focus-visible:ring-[#2167ae]/30 disabled:cursor-not-allowed disabled:opacity-50 transition-colors",
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }
